import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { BazaNcDataAccessModule } from '@scaliolabs/baza-nc-data-access';
import {
    BackLinkComponent,
    CalculatorFormComponent,
    ConfirmModalComponent,
    IframeIntegrationComponent,
    KycDisapprovedAlertComponent,
    PaymentAccountBalanceComponent,
    PaymentBankAccountComponent,
    PaymentCardComponent,
    PaymentHeaderComponent,
    PersonalInfoComponent,
    RegCfConsentComponent,
    RegCfOverviewComponent,
    SummaryComponent,
} from '@scaliolabs/baza-web-ui-components';
import { UtilModule } from '@scaliolabs/baza-web-utils';

import { PurchaseAgreementComponent } from './agreement/agreement.component';
import { PurchaseStateModule } from './data-access';
import { PurchaseDetailsComponent } from './details/details.component';
import { PurchaseDetailsRecurringComponent } from './details-recurring/details-recurring.component';
import { PurchaseDoneComponent } from './done/done.component';
import { PurchaseMethodsComponent } from './methods/methods.component';
import { PurchasePaymentComponent } from './payment/payment.component';
import { PurchaseComponent } from './purchase.component';
import { PaymentEditModule, RegCFLimitComponent, WithdrawComponent } from './ui-components';

@NgModule({
    declarations: [
        PurchaseComponent,
        PurchaseDetailsComponent,
        PurchaseDetailsRecurringComponent,
        PurchaseAgreementComponent,
        PurchasePaymentComponent,
        PurchaseMethodsComponent,
        PurchaseDoneComponent,
    ],
    imports: [
        BackLinkComponent,
        BazaNcDataAccessModule,
        CalculatorFormComponent,
        CommonModule,
        ConfirmModalComponent,
        FormsModule,
        IframeIntegrationComponent,
        KycDisapprovedAlertComponent,
        NzAlertModule,
        NzButtonModule,
        NzCheckboxModule,
        NzFormModule,
        NzGridModule,
        NzInputNumberModule,
        NzModalModule,
        NzPopoverModule,
        NzSkeletonModule,
        NzStepsModule,
        PaymentAccountBalanceComponent,
        PaymentBankAccountComponent,
        PaymentCardComponent,
        PaymentEditModule,
        PaymentHeaderComponent,
        PersonalInfoComponent,
        PurchaseStateModule,
        ReactiveFormsModule,
        RegCfConsentComponent,
        RegCFLimitComponent,
        RegCfOverviewComponent,
        RouterModule,
        SummaryComponent,
        UtilModule,
        WithdrawComponent,
    ],
    exports: [
        PurchaseAgreementComponent,
        PurchaseComponent,
        PurchaseDetailsComponent,
        PurchaseDetailsRecurringComponent,
        PurchaseDoneComponent,
        PurchaseMethodsComponent,
        PurchasePaymentComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PurchaseFlowModule {}
